import { csManager, lsManager, ssManager } from '@shared/utils';
import authService from '@shared/global/auth/auth.service';
import { ResponseErrorDto } from '@interfaces/models';
import { fallbackLng } from '@shared/global/i18n';
import { getHttpExtras } from '@helpers/utils';
import * as Sentry from '@sentry/react';
import ky from 'ky';

export const httpClient = ky.create({
  prefixUrl: import.meta.env.VITE_API_URL,
  hooks: {
    beforeRequest: [
      async (request): Promise<void> => {
        /** Add Authorization header with Bearer token and language */
        const token = await authService.getAccessToken();

        if (!!token) request.headers.set('Authorization', `Bearer ${token}`);

        const language = lsManager.get('LANGUAGE') ?? fallbackLng;
        if (!!language) request.headers.set('Language', language);

        const companyId = ssManager.get('COMPANY_ID') ?? null;
        if (!!companyId) request.headers.set('Company-Id', companyId);

        const sessionId = csManager.get('SESSION_ID') ?? null;
        if (!!sessionId) request.headers.set('X-SC-Session-Id', sessionId);
      },
    ],
    beforeError: [
      async (error) => {
        Sentry.captureException(error, { level: 'error', extra: await getHttpExtras(error) });
        return error;
      },
      async (error) => {
        if (error.response) {
          // Handle 401 Unauthorized - reload the page
          if (error.response.status === 401) {
            authService.login();
            return error;
          }

          const errorData = await error.response.json();
          throw errorData as { error: ResponseErrorDto };
        }
        throw new Error(`Network error: ${error.message}`);
      },
    ],
  },
});
